module.exports = __webpack_public_path__ + "static/media/trainVideo6.4ec957b2.m4v";